import { useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import "react-toastify";
import Services from "../services/services";
import { setCurrentUser } from "../reducers/authSlice";
import { useEffect, useState } from "react";

const PrecheckAuthRoute = () => {
  const [result, setResult] = useState(null);
  const dispatch = useDispatch();

  const check_authentication = async () => {
    try {
      const result = await Services.UserAuth.me();
      const data = await result.json();
      if (result.ok && data.success === true) {
        dispatch(setCurrentUser(data.data));
      }
    } catch (error) {
      console.error("Error checking authentication:", error);
    } finally {
      setResult(<Outlet />);
    }
  };
  
  useEffect(() => {
    check_authentication();
  }, []);

  return result;
};

export default PrecheckAuthRoute;
